import Main from '@/components/main'
const eipMenusRouters = [{
  name: '',
  path: '/',
  meta: {
    hideInMenu: true
  },
  component: () => import('@/components/main/main-simplicity.vue'),
  children: [{
    name: 'tenant-cert',
    path: '/tenant-cert',
    meta: {
      hideInMenu: true,
      notCache: false,
      showAlways: true,
      title: '机构认证',
      icon: 'ios-globe',
      access: ['tenant-cert']
    },
    component: () => import('@/view/verb/index.vue')
  }]
}, {
  name: 'sys-tenant-manage',
  path: '/sys-tenant-manage',
  meta: {
    hideInMenu: false,
    notCache: false,
    showAlways: true,
    title: '机构审核管理',
    icon: 'ios-globe',
    access: ['sys-tenant-manage']
  },
  component: Main,
  children: [{
    name: 'sys-tenant-reg-list',
    path: 'sys-tenant-reg-list',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: false,
      title: '机构注册记录',
      icon: 'ios-create-outline',
      access: ['sys-tenant-reg-list']
    },
    component: () => import('@/view/sys-manage/tenant/tenant-reg-list.vue')
  }, {
    name: 'sys-tenant',
    path: 'sys-tenant',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '机构管理',
      icon: 'ios-globe',
      access: ['sys-tenant']
    },
    component: () => import('@/view/sys-manage/tenant/tenant-list.vue')
  }]
}, {
  path: '/supervise/department',
  name: 'department',
  meta: {
    hideInMenu: false,
    notCache: false,
    showAlways: false,
    title: '监管部门',
    icon: 'md-home',
    access: ['supervise-department']
  },
  component: Main,
  children: [{
    path: 'department-list',
    name: 'department-list',
    meta: {
      hideInMenu: false,
      title: '监管部门',
      notCache: false,
      icon: 'ios-paper',
      access: ['department-list']
    },
    component: () => import('@/view/fts/supervise/department/department-list.vue')
  }]
}, {
  name: 'cache-manage',
  path: '/cache-manage',
  meta: {
    hideInMenu: false,
    notCache: false,
    showAlways: false,
    title: '缓存管理',
    icon: 'md-square',
    access: ['cache-manage']
  },
  component: Main,
  children: [{
    name: 'sys_cache_list',
    path: 'sys_cache_list',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '系统缓存',
      icon: 'md-easel',
      access: ['sys_cache_list']
    },
    component: () => import('@/view/sys-manage/cache/index.vue')
  }]
}, {
  name: 'sys_monitor',
  path: '/sys_monitor',
  meta: {
    hideInMenu: false,
    notCache: false,
    showAlways: true,
    title: '系统监控',
    icon: 'ios-desktop',
    access: ['sys_monitor']
  },
  component: Main,
  children: [{
    name: 'sys-error-log',
    path: 'sys-error-log',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '错误日志',
      icon: 'ios-bug',
      access: ['sys-error-log']
    },
    component: () => import('@/view/sys-manage/log/error-log-list.vue')
  }, {
    name: 'sys-oper-log',
    path: 'sys-oper-log',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '操作日志',
      icon: 'ios-create',
      access: ['sys-oper-log']
    },
    component: () => import('@/view/sys-manage/log/oper-log-list.vue')
  }]
}, {
  name: 'sys_orgs',
  path: '/sys_orgs',
  meta: {
    hideInMenu: false,
    notCache: false,
    showAlways: true,
    title: '组织管理',
    icon: 'md-apps',
    access: ['sys_orgs']
  },
  component: Main,
  children: [{
    name: 'sys_orgs_list',
    path: 'sys_orgs_list',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '组织树管理',
      icon: 'md-contract',
      access: ['sys_orgs_list']
    },
    component: () => import('@/view/sys-manage/org/list.vue')
  }, {
    name: 'sys_orgs_manage',
    path: 'sys_orgs_manage',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '机构管理',
      icon: 'md-funnel',
      access: ['sys_orgs_manage']
    },
    component: () => import('@/view/sys-manage/org/index.vue')
  }, {
    name: 'sys_post',
    path: 'sys_post',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '岗位管理',
      icon: 'md-git-merge',
      access: ['sys_post']
    },
    component: () => import('@/view/sys-manage/post/index.vue')
  }, {
    name: 'sys_employee',
    path: 'sys_employee',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '员工管理',
      icon: 'md-people',
      access: ['sys_employee']
    },
    component: () => import('@/view/sys-manage/employee/index.vue')
  }]
}, {
  name: 'sys_pms',
  path: '/sys_pms',
  meta: {
    hideInMenu: false,
    notCache: false,
    showAlways: true,
    title: '权限管理',
    icon: 'md-lock',
    access: ['sys_pms']
  },
  component: Main,
  children: [{
    name: 'sys_role',
    path: 'sys_role',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '角色管理',
      icon: 'md-people',
      access: ['sys_role']
    },
    component: () => import('@/view/sys-manage/role/index.vue')
  }, {
    name: 'sys_user',
    path: 'sys_user',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '用户管理',
      icon: 'md-person',
      access: ['sys_user']
    },
    component: () => import('@/view/sys-manage/user/index.vue')
  }, {
    name: 'sys-manage-user',
    path: 'sys-manage-user',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '二级管理员',
      icon: 'md-person-add',
      access: ['sys-manage-user']
    },
    component: () => import('@/view/sys-manage/user/manage-user-list.vue')
  }, /* {
    name: 'dataPermIndex',
    path: 'dataPermIndex',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '数据权限管理',
      icon: 'md-key',
      access: ['dataPermIndex']
    },
    component: () => import('@/view/sys-manage/data-perm/index.vue')
  }, */ {
    name: 'sys-super-manage',
    path: 'sys-super-manage',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '超级管理员',
      icon: 'md-happy',
      access: ['sys-super-manage']
    },
    component: () => import('@/view/sys-manage/super-admin/admin-list.vue')
  }]
}, {
  name: 'sys_settings',
  path: '/sys_settings',
  meta: {
    hideInMenu: false,
    notCache: false,
    showAlways: true,
    title: '系统设置',
    icon: 'md-settings',
    access: ['sys_settings']
  },
  component: Main,
  children: [{
    name: 'sys_menu',
    path: 'sys_menu',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '菜单管理',
      icon: 'md-menu',
      access: ['sys_menu']
    },
    component: () => import('@/view/sys-manage/menu/index.vue')
  }, {
    name: 'sys_dict_data',
    path: 'sys_dict_data',
    meta: {
      hideInMenu: true,
      notCache: false,
      showAlways: false,
      title: '字典数据',
      icon: 'md-paper',
      access: ['sys_dict_data']
    },
    component: () => import('@/view/sys-manage/dict/dict-data.vue')
  }, {
    name: 'sys_dict_type',
    path: 'sys_dict_type',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '字典管理',
      icon: 'md-book',
      access: ['sys_dict_type']
    },
    component: () => import('@/view/sys-manage/dict/dict-type.vue')
  }, {
    name: 'sys_area',
    path: 'sys_area',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '行政区划',
      icon: 'md-globe',
      access: ['sys_area']
    },
    component: () => import('@/view/sys-manage/area/index.vue')
  }, {
    name: 'sys_config',
    path: 'sys_config',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '参数设置',
      icon: 'md-construct',
      access: ['sys_config']
    },
    component: () => import('@/view/sys-manage/config/index.vue')
  }, {
    name: 'sysWebConfigs',
    path: 'sysWebConfigs',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '系统配置',
      icon: 'md-at',
      access: ['sysWebConfigs']
    },
    component: () => import('@/view/sys-manage/config/config-index.vue')
  }]
}, {
  name: 'help-modules',
  path: '/help-modules',
  meta: {
    hideInMenu: false,
    notCache: false,
    showAlways: false,
    title: '帮助中心',
    icon: 'md-headset',
    access: ['help-modules']
  },
  component: Main,
  children: [{
    name: 'customer-service-main',
    path: 'customer-service-main',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '联系客服',
      icon: 'md-headset',
      access: ['customer-service-main']
    },
    component: () => import('@/view/help/customer-service/customer-service-main.vue')
  }]
}]
export default eipMenusRouters



// WEBPACK FOOTER //
// ./src/router/routers-menu-eip.js